module.exports = __webpack_public_path__ + "static/fb-share-28ea25db2f2b046704be42dc846756af.jpg";